<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <h5>Général</h5>
        </p-card>
    </div>
</div>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <p-tabView [scrollable]="true" orientation="left">
                <p-tabPanel header="Bons de commande" leftIcon="pi pi-file-pdf">
                    <div class="fluid formgrid grid">
                        <div class="flex flex-column gap-2 my-2 col-12">
                            <h5 class="m-0">Pdf des termes de paiment</h5>
                            <hr>
                            <p-fileUpload name="pdfFile"
                                [url]="uploadUrl"
                                [showUploadButton]="true" 
                                [showCancelButton]="true"
                                [withCredentials]="true"    
                                (onUpload)="onUpload($event)"
                                (onClear)="onBeforeSend($event)"
                                (onSelect)="onFileSelect($event)"
                                (onError)="onError($event)"
                                accept="application/pdf"
                                maxFileSize="10000000"
                                [multiple]="false"
                                chooseLabel="Choisir"
                                uploadLabel="Téléverser"
                                cancelLabel="Annuler"
                                [style]="{width:'auto'}"
                                mode="advanced">
                                <ng-template pTemplate="content">
                                    <div *ngIf="loading" class="flex align-items-center justify-content-center mt-2">
                                        <p-progressSpinner [style]="{width:'50px',height:'50px'}" strokeWidth="4"></p-progressSpinner>
                                    </div>
                                    <div *ngIf="pdfTermesPaiementUrl && !loading" class="flex align-items-center mt-2">
                                        <p>PDF actuel:</p>
                                        <iframe [src]="pdfTermesPaiementUrl" 
                                                width="100%" 
                                                height="1000px" 
                                                type="application/pdf">
                                        </iframe>
                                    </div>
                                    <div *ngIf="!loading && !pdfTermesPaiementUrl" class="flex align-items-center mt-2">
                                        <p>Aucun PDF</p>
                                    </div>
                                </ng-template>
                            </p-fileUpload>
                        </div>
                    </div>
                </p-tabPanel>
                <!-- Additional sections can be added here as needed -->
            </p-tabView>
        </p-card>
    </div>
</div> 